'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  auth: {
    activate: {
      meta_title: 'Caligram - Activation',
      title: 'Nouveau compte',
      submit: 'Activer',
      success: 'Votre compte a été activé avec succès, vous pouvez vous connecter.',
      errors: {
        account_not_found: 'Compte introuvable.',
        already_activated: 'Ce compte a déjà été activé.',
        default: "Une erreur s'est produite."
      }
    },
    form: {
      code: 'Code',
      email: 'Courriel',
      name: 'Nom',
      password: 'Mot de passe',
      choose_password: 'Choisir un mot de passe'
    },
    login: {
      forget_password: 'Mot de passe oublié',
      meta_title: 'Caligram - Connexion',
      new_account: 'Créer un nouveau compte',
      please_wait: 'Connexion réussie. Redirection en cours...',
      submit: 'Connexion',
      title: 'Connexion',
      unauthorizedErrorMessage: 'Nom d\'utilisateur ou mot de passe inconnu.',
      badRequestErrorMessage: 'Nom d\'utilisateur ou mot de passe manquant.',
      serverErrorMessage: 'Erreur système. Veuillez réessayer dans quelques minutes.'
    },
    loginCode: {
      loading: 'Connexion...',
      meta_title: 'Caligram - Connexion',
      submit: 'Connexion',
      title: 'Connexion'
    },
    register: {
      meta_title: 'Caligram - Créer un compte',
      title: 'Créer un compte',
      success: 'Votre compte a été créé avec succès, vous pouvez vous connecter.',
      buttons: {
        go_login: 'Aller à la page de connexion'
      },
      submit: 'CRÉER LE COMPTE'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/auth.js
// module id = 2291
// module chunks = 0